import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, IconButton, Tooltip } from '@material-ui/core';
import BookmarkIcon from '@material-ui/icons/Bookmark';
import BookmarkBorderIcon from '@material-ui/icons/BookmarkBorder';
import { addFieldToBasket, removeFieldFromBasket } from '../../../redux/common/dataDictionaryBasket/action';
import { selectBasketItems } from '../../../redux/common/dataDictionaryBasket/selectors';

const useBasketToggle = (field) => {
    const dispatch = useDispatch();
    const items = useSelector(selectBasketItems);
    const inBasket = !!field && items.some((i) => i.columnKey === field.columnKey);
    const toggle = (e) => {
        // Pin lives inside clickable grid rows / list items — don't select the row too.
        if (e && e.stopPropagation) e.stopPropagation();
        if (inBasket) dispatch(removeFieldFromBasket(field.columnKey));
        else dispatch(addFieldToBasket(field));
    };
    return { inBasket, toggle };
};

/** Icon-sized pin toggle for grid rows and list items. */
const BasketPinButton = ({ field }) => {
    const { inBasket, toggle } = useBasketToggle(field);
    return (
        <Tooltip title={inBasket ? 'Remove from field basket' : 'Add to field basket'} arrow>
            <IconButton
                size="small"
                onClick={toggle}
                aria-label={`${inBasket ? 'remove' : 'add'} ${field.table}.${field.column} ${inBasket ? 'from' : 'to'} field basket`}
            >
                {inBasket
                    ? <BookmarkIcon fontSize="small" color="primary" />
                    : <BookmarkBorderIcon fontSize="small" />}
            </IconButton>
        </Tooltip>
    );
};

/** Text-button variant for detail panels. */
export const BasketToggleButton = ({ field, style }) => {
    const { inBasket, toggle } = useBasketToggle(field);
    return (
        <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={toggle}
            startIcon={inBasket ? <BookmarkIcon /> : <BookmarkBorderIcon />}
            style={style}
        >
            {inBasket ? 'Remove from basket' : 'Add to basket'}
        </Button>
    );
};

export default BasketPinButton;
